var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.vm.closed
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.dialogTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticStyle: { "min-height": "400px" } }, [
                    _c(
                      "nav",
                      {
                        staticClass:
                          "navbar navbar-light navbar-expand-md bg-light",
                        attrs: { role: "navigation" },
                      },
                      [
                        _c("div", { staticClass: "dropdown ml-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm dropdown-toggle d-flex align-items-center",
                              class: _vm.tag
                                ? "btn-info"
                                : "btn-outline-secondary",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-filter mr-1",
                                class: _vm.tag ? "text-warning" : "text-muted",
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Tag")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  class: { active: _vm.tag === null },
                                  on: {
                                    click: function ($event) {
                                      _vm.tag = null
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        None\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _vm._l(_vm.tags, function (t) {
                                return _c(
                                  "a",
                                  {
                                    key: t,
                                    staticClass: "dropdown-item",
                                    class: { active: _vm.tag === t },
                                    on: {
                                      click: function ($event) {
                                        _vm.tag = t
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(t) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "form-inline my-2 my-lg-0 ml-sm-2",
                            attrs: { role: "search" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchPhrase,
                                  expression: "searchPhrase",
                                },
                              ],
                              staticClass: "form-control form-control-sm",
                              attrs: { type: "search", placeholder: "Search" },
                              domProps: { value: _vm.searchPhrase },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.searchPhrase = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.tag || _vm.searchPhrase
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "alert alert-info alert-dismissible fade show d-flex align-items-center mt-3",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("i", { staticClass: "fas fa-info-circle mr-2" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                Showing users\n                                "
                              ),
                              _vm.tag
                                ? _c("span", [
                                    _vm._v("filtered by tag: "),
                                    _c("strong", [_vm._v(_vm._s(_vm.tag))]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tag && _vm.searchPhrase
                                ? _c("span", [_vm._v(" and ")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.searchPhrase
                                ? _c("span", [
                                    _vm._v('matching "'),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.searchPhrase)),
                                    ]),
                                    _vm._v('"'),
                                  ])
                                : _vm._e(),
                              _vm._v(".\n                            "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "close ml-auto",
                                attrs: { type: "button" },
                                on: { click: _vm.clearFilters },
                              },
                              [_c("span", [_vm._v("×")])]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("table", { staticClass: "table table-bordered" }, [
                      _c("thead", [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticStyle: {
                                width: "40px",
                                "min-width": "40px !important",
                              },
                            },
                            [
                              _c("div", { staticClass: "btn-group" }, [
                                _vm.noneSelected
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "pointer",
                                        on: { click: _vm.selectAll },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-square",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.anySelected && !_vm.allSelected
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "pointer",
                                        on: { click: _vm.unselectAll },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-minus-square",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.anySelected && _vm.allSelected
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "pointer",
                                        on: { click: _vm.unselectAll },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-square-check",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", { staticStyle: { width: "300px" } }, [
                            _vm._v("User"),
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Tags")]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.usersView, function (u) {
                          return _c("tr", { key: u.Id }, [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: u.IsUiSelected,
                                    expression: "u.IsUiSelected",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(u.IsUiSelected)
                                    ? _vm._i(u.IsUiSelected, null) > -1
                                    : u.IsUiSelected,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = u.IsUiSelected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            u,
                                            "IsUiSelected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            u,
                                            "IsUiSelected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(u, "IsUiSelected", $$c)
                                    }
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "p",
                                { staticClass: "fg-color-gray mb-0 mt-1" },
                                [_c("span", [_vm._v(_vm._s(u.Name))])]
                              ),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(u.Email)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              _vm._l(u.Tags, function (t) {
                                return _c(
                                  "span",
                                  {
                                    key: t,
                                    staticClass: "badge mr-1 pointer",
                                    class:
                                      _vm.tag === t
                                        ? "badge-info"
                                        : "badge-secondary",
                                    on: {
                                      click: function ($event) {
                                        _vm.tag = t
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(t) +
                                        "\n                                        "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        disabled: _vm.selected.length === 0,
                      },
                      on: { click: _vm.handleAssign },
                    },
                    [_vm._v("Assign (" + _vm._s(_vm.selected.length) + ")")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }